var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.323,
    height: 10.591,
    viewBox: "0 0 10.323 10.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-down",
    "data-name": "Icon awesome-arrow-down",
    d: "M10.028,6.753l.525.525a.565.565,0,0,1,0,.8l-4.593,4.6a.565.565,0,0,1-.8,0l-4.6-4.6a.565.565,0,0,1,0-.8l.525-.525a.568.568,0,0,1,.811.009L4.613,9.611V2.817A.566.566,0,0,1,5.18,2.25h.756a.566.566,0,0,1,.567.567V9.611L9.218,6.762a.564.564,0,0,1,.811-.009Z",
    transform: "translate(-0.397 -2.25)",
    fill: "#107889"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullArrowDown);
export default __webpack_public_path__ + "static/media/fullArrowDown.85d2d0cc.svg";
export { ForwardRef as ReactComponent };